import axios from 'axios'
import { apiUrl } from '@/constants/config'

export const postMethodConfig = {
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
}

export const axiosWithBaseUrl = axios.create({
  baseURL: apiUrl
})

const axiosWithToken = axios.create({
  baseURL: apiUrl
})

axiosWithToken.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers = {
        Authorization: `Bearer ${token}`,
        Accept: 'application/json'
      }
    }
    return config
  },
  (error) => {
    Promise.reject(error)
  }
)

export default axiosWithToken
